function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import payment from 'payment';
import { Input, Checkbox, Select, Error } from 'module-tsl-ui-elements';
import { CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import { countryCode } from './types';

var CreditCardEntry = /*#__PURE__*/function (_Component) {
  _inherits(CreditCardEntry, _Component);

  var _super = _createSuper(CreditCardEntry);

  function CreditCardEntry() {
    _classCallCheck(this, CreditCardEntry);

    return _super.apply(this, arguments);
  }

  _createClass(CreditCardEntry, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.countryCodes.length === 0) {
        this.props.loadCountryCodes();
      } // payment.formatCardNumber(this.cardNumber);
      // payment.formatCardCVC(this.cardCvc);
      // payment.formatCardExpiry(this.cardExpiry);


      if (!this.props.hasStoredCard) {
        this.cardName.focus();
      }
    }
  }, {
    key: "onChange",
    value: function onChange(field) {
      var _this = this;

      return function (e) {
        var updates = {};
        updates[field] = e.target.value;

        _this.props.setSafeFields(updates);
      };
    }
  }, {
    key: "onChangeCheckbox",
    value: function onChangeCheckbox(field) {
      var _this2 = this;

      return function (e) {
        var updates = {};
        updates[field] = e.target.checked;

        _this2.props.setSafeFields(updates);
      };
    }
  }, {
    key: "onGenerateCc",
    value: function onGenerateCc(e) {
      e.preventDefault();
      var updates = {
        name: 'Test Name',
        number: '4444 3333 2222 1111',
        expiry: '10 / 20',
        cvc: '737',
        country: 'US',
        postalCode: '12345'
      };
      this.props.setSafeFields(updates);
    }
  }, {
    key: "onChangeStoredCard",
    value: function onChangeStoredCard() {
      this.props.clearStoredCard();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          countryCodes = _this$props.countryCodes,
          submitted = _this$props.submitted,
          paymentError = _this$props.paymentError,
          loadingError = _this$props.loadingError,
          isTestCreditCardUsable = _this$props.isTestCreditCardUsable,
          isPostalCodeNeeded = _this$props.isPostalCodeNeeded,
          isEmailConfirmationNeeded = _this$props.isEmailConfirmationNeeded,
          hasStoredCard = _this$props.hasStoredCard,
          storedCard = _this$props.storedCard,
          isCVCNeeded = _this$props.isCVCNeeded,
          isBalanceOnly = _this$props.isBalanceOnly,
          safeFieldsValidation = _this$props.safeFieldsValidation,
          _this$props$safeField = _this$props.safeFields,
          country = _this$props$safeField.country,
          number = _this$props$safeField.number,
          email = _this$props$safeField.email,
          name = _this$props$safeField.name,
          expiry = _this$props$safeField.expiry,
          cvc = _this$props$safeField.cvc,
          rememberCard = _this$props$safeField.rememberCard,
          postalCode = _this$props$safeField.postalCode,
          featureStripe = _this$props.featureStripe;
      var countries = countryCodes.map(function (item) {
        return {
          value: item.id,
          label: item.name
        };
      });
      var postalCodeLabel = country === 'US' ? 'Zip Code' : 'Postal code';
      var postalCodeNeededText = "Please provide your ".concat(postalCodeLabel, " to get your 100% discount");
      var emailErrorText = isEmailConfirmationNeeded ? 'Please validate your email address to get your 100% discount' : 'Enter a valid email address';
      var emailConfirmationLink = /*#__PURE__*/React.createElement("a", {
        className: "tds-form__error",
        target: "_blank",
        rel: "noopener noreferrer",
        href: "/authn/resend-confirmation-email"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon icon-stop icon-red"
      }), " Re-send validation email");

      var shouldDisplayError = function shouldDisplayError(field) {
        return submitted && !field && !isBalanceOnly;
      };

      var emailClass = classnames('tds-form__group', {
        'tes-has-error': shouldDisplayError(safeFieldsValidation.email)
      });
      var postalCodeReqClass = classnames('', {
        'postal-req-error': isPostalCodeNeeded
      });
      var storedCreditNumber = '';
      var storedExpiryDate = '';
      var storedCardVariant = '';

      if (hasStoredCard) {
        storedCreditNumber = "**** **** **** ".concat(storedCard.lastFourDigits ? storedCard.lastFourDigits : '****');
        storedExpiryDate = "".concat(('0' + String(storedCard.expiryMonth)).slice(-2), "/").concat(String(storedCard.expiryYear).substr(-2, 2)); // eslint-disable-line prefer-template

        storedCardVariant = storedCard.variant;
      }

      var cardType = hasStoredCard ? storedCardVariant : payment.fns.cardType(number);

      var setCardNumberRef = function setCardNumberRef(node) {
        _this3.cardNumber = node;
      };

      var setCardCvcRef = function setCardCvcRef(node) {
        _this3.cardCvc = node;
      };

      var setCardExpiryRef = function setCardExpiryRef(node) {
        _this3.cardExpiry = node;
      };

      var setCardNameRef = function setCardNameRef(node) {
        _this3.cardName = node;
      };

      var saveCardMessage = /*#__PURE__*/React.createElement("article", null, /*#__PURE__*/React.createElement(Checkbox, {
        id: "payment-remember-card",
        disabled: this.props.isBalanceOnly,
        checked: rememberCard,
        onChange: this.onChangeCheckbox('rememberCard'),
        isDark: true
      }), /*#__PURE__*/React.createElement("label", {
        className: "highlight-nowrap text text--sm text--white",
        htmlFor: "payment-remember-card"
      }, "Save my card for future purchases"));
      var cvcMessage = /*#__PURE__*/React.createElement("div", {
        className: "cvc-message"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon icon-tds-info-2 icon-white icon--unit-md"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text text--white text--xs"
      }, "Please confim your CVC number to proceed"), /*#__PURE__*/React.createElement("span", {
        className: "cvc-message__arrow"
      }));
      var stripeStyles = {
        base: {
          color: '#fff',
          fontFamily: 'inherit',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#fff'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "modal-body payment-details"
      }, paymentError && /*#__PURE__*/React.createElement("div", {
        className: "margin-bottom-md"
      }, /*#__PURE__*/React.createElement(Error, {
        error: "We were unable to charge your card. Double-check your details below."
      })), loadingError && /*#__PURE__*/React.createElement("div", {
        className: "margin-bottom-md"
      }, /*#__PURE__*/React.createElement(Error, {
        error: "We were unable to load your card details. Re-enter your details below."
      })), /*#__PURE__*/React.createElement("h3", {
        className: "heading heading--md text text--white margin-bottom-md l-flex-vcenter-spaced"
      }, /*#__PURE__*/React.createElement("span", null, "Payment details"), /*#__PURE__*/React.createElement("span", null, isTestCreditCardUsable && /*#__PURE__*/React.createElement("span", {
        className: "tds-btn tds-btn--sm tds-btn--primary",
        onClick: function onClick(e) {
          return _this3.onGenerateCc(e);
        }
      }, "\u03C0"), hasStoredCard && /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this3.onChangeStoredCard();
        },
        className: "edit-payments-details",
        title: "Change payment details"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon icon-tds-edit-1 icon-white icon--unit-sm"
      }), "Edit"))), /*#__PURE__*/React.createElement("form", {
        role: "form",
        autoComplete: "on"
      }, /*#__PURE__*/React.createElement("div", {
        className: emailClass
      }, /*#__PURE__*/React.createElement(Input, {
        type: "email",
        placeholder: "Email address",
        value: email,
        onChange: this.onChange('email'),
        autoComplete: "email",
        disabled: hasStoredCard || this.props.isBalanceOnly,
        error: shouldDisplayError(safeFieldsValidation.email) && emailErrorText,
        required: true,
        inverse: true
      }), /*#__PURE__*/React.createElement("span", {
        className: "validation-email-cta tes-help-block"
      }, emailConfirmationLink)), !hasStoredCard && /*#__PURE__*/React.createElement("div", {
        className: "tds-form__group"
      }, /*#__PURE__*/React.createElement(Input, {
        type: "text",
        placeholder: "Name on card",
        value: name,
        onChange: this.onChange('name'),
        autoComplete: "name",
        inputRef: setCardNameRef,
        disabled: hasStoredCard || this.props.isBalanceOnly,
        error: shouldDisplayError(safeFieldsValidation.name) && !hasStoredCard && 'Enter the name that appears on your card',
        required: true,
        inverse: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "tds-form__group l-position-context"
      }, featureStripe && /*#__PURE__*/React.createElement(CardNumberElement, {
        style: stripeStyles,
        disabled: this.props.isBalanceOnly
      }), !featureStripe && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
        id: "cardNumber",
        type: "text",
        classNames: "cc-number",
        disabled: hasStoredCard || this.props.isBalanceOnly,
        inputRef: setCardNumberRef,
        autoComplete: "cc-number",
        autocompletetype: "cc-number",
        autoCorrect: "off",
        spellCheck: "false",
        placeholder: "Card number",
        value: hasStoredCard ? storedCreditNumber : number,
        onChange: this.onChange('number'),
        error: shouldDisplayError(safeFieldsValidation.cardNumber) && !hasStoredCard && 'Enter a valid card number',
        required: true,
        inverse: true
      }), /*#__PURE__*/React.createElement("figure", {
        className: "card-type ".concat(cardType === 'visa' ? ' card-type--visa' : '', " ").concat(cardType === 'mastercard' ? ' card-type--mastercard' : '', " ")
      }, /*#__PURE__*/React.createElement("span", {
        className: "card-type__item card-type__item--placeholder"
      }), /*#__PURE__*/React.createElement("span", {
        className: "card-type__item card-type__item--visa"
      }), /*#__PURE__*/React.createElement("span", {
        className: "card-type__item card-type__item--mastercard"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row margin-bottom-sm"
      }, /*#__PURE__*/React.createElement("div", {
        className: "secureform__expiry-container col-xs-7"
      }, featureStripe && /*#__PURE__*/React.createElement(CardExpiryElement, {
        style: stripeStyles,
        disabled: this.props.isBalanceOnly
      }), !featureStripe && /*#__PURE__*/React.createElement(Input, {
        type: "text",
        disabled: hasStoredCard || this.props.isBalanceOnly,
        inputRef: setCardExpiryRef,
        autoComplete: "cc-exp",
        autocompletetype: "cc-exp",
        placeholder: "Expires MM/YY",
        value: hasStoredCard ? storedExpiryDate : expiry,
        onChange: this.onChange('expiry'),
        error: shouldDisplayError(safeFieldsValidation.cardExpiry) && !hasStoredCard && 'Invalid expiration date',
        required: true,
        inverse: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, featureStripe && /*#__PURE__*/React.createElement(CardCVCElement, {
        style: stripeStyles,
        disabled: this.props.isBalanceOnly
      }), !featureStripe && /*#__PURE__*/React.createElement(Input, {
        type: "text",
        disabled: this.props.isBalanceOnly,
        classNames: hasStoredCard && (!isCVCNeeded || isBalanceOnly) && 'hidden',
        autoFocus: hasStoredCard,
        inputRef: setCardCvcRef,
        autoComplete: "off",
        autocompletetype: "cc-csc",
        placeholder: "CVC",
        value: hasStoredCard && isBalanceOnly ? 'CVC' : cvc,
        onChange: this.onChange('cvc'),
        error: shouldDisplayError(safeFieldsValidation.cardCvc) && 'Invalid CVC',
        required: true,
        inverse: true
      }))), /*#__PURE__*/React.createElement("div", {
        className: "margin-bottom-xml l-position-context"
      }, !hasStoredCard && saveCardMessage, hasStoredCard && !isBalanceOnly && isCVCNeeded && cvcMessage), !hasStoredCard && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h3", {
        className: "heading heading--md text text--white margin-bottom-md"
      }, "Billing address"), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-7 padding-right-none"
      }, /*#__PURE__*/React.createElement(Select, {
        id: "payment-country",
        options: [{
          isPlaceholder: true,
          label: 'Country'
        }, {
          value: 'GB',
          label: 'United Kingdom'
        }, {
          value: 'US',
          label: 'United States'
        }].concat(_toConsumableArray(countries)),
        disabled: hasStoredCard || this.props.isBalanceOnly,
        value: country,
        onChange: this.onChange('country'),
        error: shouldDisplayError(safeFieldsValidation.country) && 'Choose a country',
        required: true,
        inverse: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(Input, {
        type: "text",
        disabled: hasStoredCard || this.props.isBalanceOnly,
        id: "payment-postal-code",
        autoComplete: "postal-code",
        placeholder: postalCodeLabel,
        value: postalCode,
        onChange: this.onChange('postalCode'),
        error: shouldDisplayError(safeFieldsValidation.postalCode) && isPostalCodeNeeded && "Invalid ".concat(postalCodeLabel),
        required: true,
        inverse: true
      }))), /*#__PURE__*/React.createElement("div", {
        className: postalCodeReqClass
      }, postalCodeNeededText && /*#__PURE__*/React.createElement("span", {
        className: "tes-help-block"
      }, postalCodeNeededText)))));
    }
  }]);

  return CreditCardEntry;
}(Component);

CreditCardEntry.displayName = "CreditCardEntry";
export { CreditCardEntry as default };
CreditCardEntry.propTypes = {
  paymentError: PropTypes.object.isRequired,
  loadingError: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  countryCodes: PropTypes.arrayOf(countryCode).isRequired,
  safeFields: PropTypes.object,
  safeFieldsValidation: PropTypes.object.isRequired,
  isPostalCodeNeeded: PropTypes.bool.isRequired,
  isEmailConfirmationNeeded: PropTypes.bool.isRequired,
  hasStoredCard: PropTypes.bool.isRequired,
  storedCard: PropTypes.object.isRequired,
  isBalanceOnly: PropTypes.bool.isRequired,
  isTestCreditCardUsable: PropTypes.bool.isRequired,
  loadCountryCodes: PropTypes.func.isRequired,
  setSafeFields: PropTypes.func.isRequired,
  clearStoredCard: PropTypes.func.isRequired,
  isCVCNeeded: PropTypes.func.isRequired,
  featureStripe: PropTypes.bool.isRequired
};